import { onMounted, onUnmounted, ref } from 'vue';
import { TabDetail } from './types';

const EXPECTED_HASH_SEGMENTS = 3;

export function useTabManager(tabDetails: TabDetail[] | undefined, activeTab: number) {
  const tabIndex = ref(activeTab);

  function findTabKeyFromIndex(tabIndex: number) {
    if (!tabDetails) return;
    return tabDetails[tabIndex].hashPath;
  }

  function findHashFromTabIndex(tabIndex: number) {
    const tabKey = findTabKeyFromIndex(tabIndex);
    if (!tabKey) return;
    return `#${tabKey}`;
  }

  function goToTabFromURL() {
    const url = window.location.href;
    const hashes = url.split('#');

    if (hashes.length < EXPECTED_HASH_SEGMENTS) {
      tabIndex.value = 0;
    }

    if (hashes.length >= EXPECTED_HASH_SEGMENTS && tabDetails) {
      const hash = hashes[2].replace('#', '');
      const index = tabDetails.findIndex((tab) => tab.hashPath === hash);

      if (index !== -1) {
        tabIndex.value = index;
      }
    }
  }

  function updateURL() {
    const url = window.location.href;
    const [baseURL, currentHashPath] = url.split('#');
    const newHash = findHashFromTabIndex(tabIndex.value);
    if (!newHash) return;
    const updatedURL = `${baseURL}#${currentHashPath}${newHash}`;
    history.replaceState(null, '', updatedURL);
  }

  function handleTabChange(index: number) {
    tabIndex.value = index;
    updateURL();
  }

  onMounted(() => {
    goToTabFromURL();
    if (tabIndex.value !== 0) updateURL();
    window.addEventListener('hashchange', goToTabFromURL);
  });

  onUnmounted(() => {
    window.removeEventListener('hashchange', goToTabFromURL);
  });

  return { handleTabChange, tabIndex };
}
